import { styled } from '@mui/material';

// Badge de ícono de los contadores. Antes era styled-components con hex fijos
// (#57482B/#F9BD4E) que quedaban marrón-sobre-marrón en modo claro; ahora usa
// tokens mode-aware (tinte dorado suave + dorado legible por modo).
const StyledSingleCounterIconContainer = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  backgroundColor: theme.palette.gold.soft,
  borderRadius: '10px',
  padding: '7px 5px',
  '& svg': {
    color: theme.palette.gold.main,
    display: 'block',
    fontSize: '1.6rem'
  },
  [theme.breakpoints.up('sm')]: {
    '& svg': { fontSize: '2rem' }
  },
  [theme.breakpoints.up('sm')]: {
    padding: '12px 8px'
  },
  [theme.breakpoints.up('md')]: {
    padding: '15px 10px'
  }
}));

export default StyledSingleCounterIconContainer;
